import React from 'react';

const GuardContext = React.createContext<string[]>([]);

export default GuardContext;
